import styled from "styled-components";

import awardBg from '@/images/day-award-box.png'
import awardBgHover from '@/images/day-award-box-hover.png'

const View = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  width: 520px;
  height: 452px;
  padding-top: 80px;
  padding-left: 27px;

  div.taskItem {
    position: relative;
    height: 82px;
    width: 100%;
    margin-bottom: 19px;

    & > p {
      vertical-align: top;
      width: 130px;
      line-height: 86px;
      text-align: center;
      display: inline-block;
      font-size: 16px;
      font-weight: bold;
      color: #fff;
      text-shadow: 1px 1px 2px #6597e1, -1px -1px 2px #6597e1;
    }

    ul {
      text-align: center;
      display: inline-block;
      position: relative;
      top: 50%;
      transform: translateY(-50%);

      li {
        display: inline-block;
        width: 77px;
        height: 79px;
        position: relative;
        background-image: url("${awardBg}");
        cursor: pointer;
        transition: all 0.15s;
        margin: 0 2px;

        &:hover,
        &.active {
          background-image: url("${awardBgHover}");
        }

        &.normal {
          &:hover {
            background-image: url("${awardBg}");
          }
        }

        img {
          width: 44px;
          height: 45px;
          position: absolute;
          left: 50%;
          top: 7px;
          transform: translateX(-50%);
        }

        p {
          color: #2c9fda;
          font-weight: bold;
          position: absolute;
          bottom: 8px;
          width: 100%;
          font-size: 12px;
        }
      }
    }
  }

  p.tip {
    cursor: pointer;
    position: absolute;
    bottom: 30px;
    left: 0;
    padding: 0 55px;
    width: 100%;
    font-size: 14px;
    line-height: 28px;

    span:nth-child(1) {
      color: #2089ff;
      float: left;
    }

    span:nth-child(2) {
      float: right;
      text-decoration: underline;
      color: #2089ff;
    }
  }

  .button {
    position: relative;
    left: 0px;
    top: 0px;
  }
`;

export {
  View
}
